const topics = [
  {
    title: "----African Americans----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "",
    lyrics: [
      "(Chorus)",
"We worked these lands, we built it strong,",
"Our voices raised in prayer and song.",
"Through the struggle, through the pain,",
"We stood tall and broke the chain!",

"(Verse)",
"Fields of cotton, hands so worn,",
"Still we dreamed of brighter morn.",
"Music, food, the arts we made,",
"A culture rich that never fades.",
"Fought for freedom, won the right,",
"Marching on, still shining bright!",

"(Chorus)",
"We worked these lands, we built it strong,",
"Our voices raised in prayer and song.",
"Through the struggle, through the pain,",
"We stood tall and broke the chain!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----American Natives----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
     "(Chorus)",
"Mountains high and rivers wide,",
"This was home with strength and pride.",
"Cherokee and Tuscarora stand,",
"The first to live upon this land!",

"(Verse)",
"Planted corn, the three crops grew,",
"Taught the settlers what to do.",
"Stories passed from old to new,",
"A culture strong, a people true.",
"Faced the hardships, lost and won,",
"Still, their spirit carries on!",

"(Chorus)",
"Mountains high and rivers wide,",
"This was home with strength and pride.",
"Cherokee and Tuscarora stand,",
"The first to live upon this land!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Enslaved People----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----French Huguenots----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Germans----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
     "(Chorus)",
"They built with hands, they worked with care,",
"Crafted towns both strong and fair.",
"From the farms to skilled designs,",
"Their legacy still stands in time!",

"(Verse)",
"Moravian towns with streets so neat,",
"Music, trade, and food so sweet.",
"Hardwood tables, houses strong,",
"Their craftsmanship still lasts so long.",
"In fields, in shops, they made their way,",
"North Carolina thanks them today!",

"(Chorus)",
"They built with hands, they worked with care,",
"Crafted towns both strong and fair.",
"From the farms to skilled designs,",
"Their legacy still stands in time!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Highland Scots----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
     "(Chorus)",
"Brave and bold, they crossed the sea,",
"Highland Scots in history.",
"In Cape Fear they found their home,",
"Through the hills they’d fight and roam!",

"(Verse)",
"Kilts and pipes, their music played,",
"Kept traditions, never swayed.",
"Farmers strong, they worked the land,",
"Building homes with steady hands.",
"Spoke in Gaelic, held their pride,",
"Stayed together, side by side.",
"Though they fought and took some scars,",
"Their culture still shines like the stars!",

"(Chorus)",
"Brave and bold, they crossed the sea,",
"Highland Scots in history.",
"In Cape Fear they found their home,",
"Through the hills they’d fight and roam!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Indentured Servants----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Moravians----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"They built with faith, they built with skill,",
"Moravian hearts are working still.",
"Music, crafts, a peaceful way,",
"North Carolina sings today!",

"(Verse)",
"In Salem town, they made their start,",
"With careful hands and honest hearts.",
"Church bells rang, their voices true,",
"Bringing light in all they do.",
"Skilled in pottery, wood, and trade,",
"Their lasting art is finely made.",
"Schools they built, with wisdom bright,",
"Learning grew in morning light.",
"Taught the world their songs and trade,",
"A legacy that won’t fade!",

"(Chorus)",
"They built with faith, they built with skill,",
"Moravian hearts are working still.",
"Music, crafts, a peaceful way,",
"North Carolina sings today!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Lutheran----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"Faith and knowledge, side by side,",
"Lutherans helped this state with pride.",
"Building schools and churches bright,",
"Standing strong to teach what’s right!",

"(Verse)",
"From Germany they made their way,",
"Found a place where they could stay.",
"Plowed the land, grew crops so fine,",
"Taught the children, shared their minds.",
"Built their churches, raised them tall,",
"Welcomed neighbors, helped them all.",
"Songs of worship filled the air,",
"Faith and learning, always there!",
"Their voices strong, their hands so true,",
"Left their mark in all they do!",

"(Chorus)",
"Faith and knowledge, side by side,",
"Lutherans helped this state with pride.",
"Building schools and churches bright,",
"Standing strong to teach what’s right!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Quakers----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"Peace and justice, freedom’s light,",
"Quakers stood for what is right.",
"Helping others, making change,",
"North Carolina knows their name!",

"(Verse)",
"They spoke up loud, they took a stand,",
"For all the people in this land.",
"Against the chains, they paved the way,",
"Helping slaves to flee away.",
"Through secret paths and underground,",
"They kept them safe, they stood their ground.",
"They built their schools, they made it known,",
"Every heart should find a home!",

"(Chorus)",
"Peace and justice, freedom’s light,",
"Quakers stood for what is right.",
"Helping others, making change,",
"North Carolina knows their name!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Scots Irish----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"Through the hills and fields so wide,",
"Scots-Irish walked with strength and pride.",
"Building homes and standing tall,",
"Their spirit lives within us all!",

"(Verse)",
"Presbyterians filled the land,",
"With churches built by steady hands.",
"Fought for freedom, brave and bold,",
"On the frontier, stories told.",
"They carved their way, they faced the fight,",
"For their families, for what’s right!",
"Farmed the land, they worked with care,",
"Built their towns with faith and prayer.",
"Through the mountains, through the plains,",
"Their legacy forever remains!",

"(Chorus)",
"Through the hills and fields so wide,",
"Scots-Irish walked with strength and pride.",
"Building homes and standing tall,",
"Their spirit lives within us all!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Small Farm Culture----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Plantation Culture----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC Colonial Art----",
    subtitle1: "Topic: 1",
    description: "4.B.1 Understand ways in which values and beliefs have influenced the development of North Carolina’s identity as a state.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Elected Leaders in NC----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Branches of Government----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----State Supreme Court----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----General Assembly----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Checks & Balances----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC State Constitution 1776----",
    subtitle1: "Topic: 1",
    description: "4.C&G.1 Understand the role of citizens in local and state government.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC Mineral Resources----",
    subtitle1: "Topic: 1",
    description: "4.E.1 Understand how economic decisions and resources affect the economy of North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Bankruptcy----",
    subtitle1: "Topic: 1",
    description: "4.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Credits & Debts----",
    subtitle1: "Topic: 1",
    description: "4.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Interest Rates----",
    subtitle1: "Topic: 1",
    description: "4.E.2 Understand the impact of personal financial decisions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC 3 Regions----",
    subtitle1: "Topic: 1",
    description: "4.G.1 Understand the role geography has played in the development of North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"North Carolina’s 3 Regions.",
"North Carolina’s 3 Regions.",
"Coastal Plain, Piedmont, and The Mountains.",

"(Verse)",
"Coastal Plain low flat land, Coastal Plain low flat land.",
"Eastern North Carolina, near the Atlantic Ocean.",
"Coastal Plain has two parts, Coastal Plain has two parts.",
"The outer Coastal Plain on the east side,",
"The inner Coastal Plain on the west side.",
"Piedmont rolling hills.",
"Piedmont low mountains.",
"Piedmont wide plateau that rise above all the land around it.",
"Blue Ridge Mountains are rounded part of the Appalachian Mountains.",
"Great Smoky Mountains are rounded part of the Appalachian Mountains.",
"Western North Carolina have mountains, that’s part of the Appalachian Mountains.",
"The Appalachian Mountains are mountains that stretch from Canada to Alabama.",

"(Chorus)",
"North Carolina’s 3 Regions.",
"North Carolina’s 3 Regions.",
"Coastal Plain, Piedmont, and The Mountains.",

"© Smart Board Learning, LLC. All rights reserved.",

    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC Coastal Plain----",
    subtitle1: "Topic: 1",
    description: "4.G.1 Understand the role geography has played in the development of North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC Mountains----",
    subtitle1: "Topic: 1",
    description: "4.G.1 Understand the role geography has played in the development of North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----NC Piedmont----",
    subtitle1: "Topic: 1",
    description: "4.G.1 Understand the role geography has played in the development of North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Wright Brothers----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----French & Indian War----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Taxation Without Representation----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Wright Brothers----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Charlotte Hawkins Brown----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"She taught, she led, she made a way,",
"Gave kids hope for a brighter day.",
"Palmer stood, her dream came true,",
"Her lessons live in me and you!",

"(Verse 1)",
"Born in 1883, in Henderson town,",
"A bright young girl, she stood her ground.",
"Moved up north, but she came back,",
"To teach and lead where schools did lack.",
"A school shut down, but she stood tall,",
"She wouldn’t quit, she’d give her all!",

"(Chorus)",
"She taught, she led, she made a way,",
"Gave kids hope for a brighter day.",
"Palmer stood, her dream came true,",
"Her lessons live in me and you!",

"(Verse 2)",
"Palmer Memorial Institute,",
"In 1902, her school began,",
"A place to learn, a future planned.",
"Not just books, but life skills too,",
"Teaching pride in all they do.",
"For fifty years, she made it grow,",
"Her legacy still shines and glows!",

"(Chorus)",
"She taught, she led, she made a way,",
"Gave kids hope for a brighter day.",
"Palmer stood, her dream came true,",
"Her lessons live in me and you!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Black Wall Street----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Wilmington Race Riot----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Maya Angelou----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Beverly Perdue----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Wilmington 10----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Hmong----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Elizabeth Dole----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "----Ella Baker----",
    subtitle1: "Topic: 1",
    description: "4.H.1 Understand the role of various people, events, and ideas in shaping North Carolina.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },

];
export default topics;